<template>
    <div class="footer">
        @ 2026 备案号：<a
            href="https://beian.miit.gov.cn"
            target="_blank"
            >[苏ICP备05085572号-16]</a
        >
    </div>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
    text-align: center;
    padding: 20px 0;
    background: #1236c2;
    color: #fff;
}
a {
    color: #fff;
    text-decoration: none;
}
</style>